import React from "react";
import { useTranslation } from "react-i18next";

function TermsAndConditions() {
  const { t } = useTranslation();
  const termsSections = t("pages.terms.sections", { returnObjects: true });

  return (
    <main className="legal-page">
      <section className="legal-hero legal-hero--terms">
        <div className="main-container">
          <div className="legal-hero__content">
            <span className="legal-hero__kicker">PRO-VEST Capital Management</span>
            <h1 className="m-0 legal-hero__title">{t("pages.terms.title")}</h1>
            <p className="m-0 legal-hero__text">{t("pages.terms.text")}</p>
            <span className="legal-hero__date">{t("pages.terms.lastUpdated")}</span>
          </div>
        </div>
      </section>
      <section className="legal-section">
        <div className="main-container">
          <div className="legal-content">
            <p className="legal-lead">{t("pages.terms.lead")}</p>
            {termsSections.map((section) => (
              <article className="legal-card" key={section.title}>
                <h2>{section.title}</h2>
                <p>{section.text}</p>
              </article>
            ))}
            <div className="legal-notice">
              <h2>{t("pages.terms.updatesTitle")}</h2>
              <p>{t("pages.terms.updatesText")}</p>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
}
export default TermsAndConditions;